export const CAMBODIA_DIAL_CODE = "+855";
export const ORDER_REQUEST_TIMEOUT_MS = 10000;
const SHIPPING_PRICE = 0;
const TAX_RATE = 0.08;
export const DEFAULT_FINANCIAL_SETTINGS = {
  usdToKhrRate: 4100,
  khrToUsdRate: 1 / 4100,
  taxPercentage: TAX_RATE * 100,
  deliveryFee: SHIPPING_PRICE,
};

const getProductImageForColor = (product = {}, color = "") => {
  const selectedColor = String(color || "").trim().toLowerCase();
  if (!selectedColor) return product.image || product.images?.[0] || "";

  const colorImage = Array.isArray(product.colorImages)
    ? product.colorImages.find(
        (entry) => String(entry.color || "").trim().toLowerCase() === selectedColor
      )
    : null;

  return colorImage?.image || product.image || product.images?.[0] || "";
};

export const toLocalPhoneDigits = (phone = "") => {
  const digits = String(phone).replace(/\D/g, "");

  if (digits.startsWith("855")) {
    return digits.slice(3);
  }

  return digits.replace(/^0/, "");
};

export const toCambodiaPhone = (phone = "") => {
  const localDigits = toLocalPhoneDigits(phone);
  return localDigits ? `${CAMBODIA_DIAL_CODE}${localDigits}` : "";
};

export const getEffectiveCartProductPrice = (product) =>
  product?.discountPrice && product.discountPrice < product.price
    ? product.discountPrice
    : product?.price || 0;

export const getValidCartItems = (cart = []) =>
  cart.filter((item) => item.product?._id);

const checkoutValidationMessages = {
  incompleteShipping: "Please complete your shipping details before placing the order.",
  missingLocation: "Please select your delivery location on the map before placing the order.",
  emptyCart: "Your cart is empty. Add an item before placing the order.",
};

const getCheckoutValidationMessage = (key, t) =>
  typeof t === "function"
    ? t(`checkout.errors.${key}`)
    : checkoutValidationMessages[key];

export const calculateCheckoutTotals = (
  cartItems = [],
  financialSettings = DEFAULT_FINANCIAL_SETTINGS
) => {
  const subtotal = cartItems.reduce(
    (acc, item) => acc + getEffectiveCartProductPrice(item.product) * item.quantity,
    0
  );
  const taxRate = Math.max(0, Number(financialSettings.taxPercentage || 0)) / 100;
  const shippingPrice = Math.max(0, Number(financialSettings.deliveryFee || 0));
  const taxPrice = subtotal * taxRate;
  const totalPrice = subtotal + shippingPrice + taxPrice;

  return {
    subtotal,
    shippingPrice,
    taxPrice,
    totalPrice,
  };
};

export const validateCheckout = (shippingAddress, cartItems = [], t) => {
  if (
    !shippingAddress.fullName ||
    !shippingAddress.phone
  ) {
    return getCheckoutValidationMessage("incompleteShipping", t);
  }

  if (shippingAddress.latitude == null || shippingAddress.longitude == null) {
    return getCheckoutValidationMessage("missingLocation", t);
  }

  if (cartItems.length === 0) {
    return getCheckoutValidationMessage("emptyCart", t);
  }

  return "";
};

export const buildOrderPayload = ({
  cartItems,
  shippingAddress,
  paymentMethod,
  taxPrice,
  shippingPrice,
  totalPrice,
}) => ({
  orderItems: cartItems.map((item) => ({
    product: item.product._id,
    name: item.product.title || item.product.name,
    titleKm: item.product.titleKm || "",
    quantity: item.quantity,
    size: item.size || "",
    color: item.color || "",
    image: getProductImageForColor(item.product, item.color),
    price: getEffectiveCartProductPrice(item.product),
  })),
  shippingAddress: {
    ...shippingAddress,
    phone: toCambodiaPhone(shippingAddress.phone),
  },
  paymentMethod,
  taxPrice: parseFloat(taxPrice.toFixed(2)),
  shippingPrice: parseFloat(shippingPrice.toFixed(2)),
  totalPrice: parseFloat(totalPrice.toFixed(2)),
});

export const getCheckoutErrorMessage = (error) => {
  if (error.code === "ECONNABORTED") {
    return "Order request timed out. Please check the backend server and try again.";
  }

  if (error.message === "Network Error") {
    return "Cannot reach the backend API. Check that the backend server is running and VITE_API_URL is correct.";
  }

  return error.response?.data?.message || error.message || "Failed to place order";
};
